export const isFullStatic = false
export const staticPath = "/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/.nuxt/static-json"
export const publicPath = "/shop/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"